export enum EsReasons {
  MALFUNCTION_MAINTENANCE_ACCIDENT = 'Avería/Mantenimiento/Siniestro del vehículo',
  BUSINESS_TRIP = 'Viaje de trabajo',
  SUPPLIER_VISIT = 'Visita proveedor',
  MEETING = 'Reunión',

  OTHERS = 'Otros'
}
